/*
 * Copyright (c) 2026
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Process-wide cache of resolved holiday dates (ISO YYYY-MM-DD), loaded from
 * GET /api/holiday/dates once the user is authenticated (see HomePage). This is the
 * single source of truth shared with the Java backend and Postgres, replacing the old
 * moment-holiday library so admin-managed holidays flow into every business-day
 * calculation (due dates, the engagement-letter "estimated completion" text, the
 * due-date calendar, dashboard day diffs).
 */
export class HolidayDates {
  private static dates: Set<string> = new Set<string>();

  /** Replace the cached holiday set. Accepts ISO date strings (YYYY-MM-DD...). */
  static set(dateStrings: string[]): void {
    HolidayDates.dates = new Set<string>((dateStrings || []).map(d => ('' + d).substring(0, 10)));
  }

  /** True if the given moment falls on an admin-managed holiday. */
  static isHoliday(m: any): boolean {
    if (!m) return false;
    return HolidayDates.dates.has(m.format('YYYY-MM-DD'));
  }

  static get size(): number {
    return HolidayDates.dates.size;
  }
}
